import React from 'react';
import type { ForYouConfig } from '@atlassian/global-side-navigation/types';
import type { Filter } from '@atlassian/navigation-common/types';
import { MENU_ID_FOR_YOU } from '@atlassian/jira-navigation-apps-sidebar-nav4-context/src/common/constants.tsx';
import { jiraHomeRoute } from '@atlassian/jira-router-routes-jira-home-routes/src/jiraHomeRoute.tsx';
import { SkeletonNavMenuItems } from '@atlassian/jira-navigation-apps-sidebar-nav4-sidebars-common-core/src/common/ui/skeleton-nav-menu-items/main.tsx';
import { AnalyticContextProvider as RecentAnalyticContextProvider } from '@atlassian/jira-navigation-apps-sidebar-nav4-sidebars-content-recent/src/common/controllers/analytic-context/index.tsx';
import { AnalyticContextProvider as StarredAnalyticContextProvider } from '@atlassian/jira-navigation-apps-sidebar-nav4-sidebars-content-starred/src/common/controllers/analytics-context/index.tsx';
import { FAVORITE_TYPE_FILTER_MAP } from '@atlassian/jira-navigation-apps-sidebar-nav4-sidebars-content-starred/src/common/constants.tsx';
import { useRecentItems } from '../../../controllers/use-recent-items/useRecentItems.tsx';
import { useStarredItems } from '../../../controllers/use-starred-items/useStarredItems.tsx';
import { recentFlyoutEntrypoint } from '../recent/entrypoint.tsx';
import { starredFlyoutEntrypoint } from '../starred/entrypoint.tsx';
import { RecentMenuLinkItemAdaptor } from '../recent/RecentMenuLinkItemAdaptor.tsx';
import type { JiraRecentOLFItem, JiraStarredOLFItem } from '../../types.tsx';
import { StarredMenuLinkItemAdaptor } from '../starred/StarredMenuLinkItemAdaptor.tsx';

type Params = {
	recentEntryPointParams?: Record<string, unknown>;
	starredEntryPointParams?: Record<string, unknown>;
	starredFilterConfig: Filter[];
};

export function getForYouConfig(
	params: Params,
): ForYouConfig<unknown, JiraRecentOLFItem, JiraStarredOLFItem> {
	const { recentEntryPointParams, starredEntryPointParams, starredFilterConfig } = params;

	return {
		forYouItem: {
			menuItemId: MENU_ID_FOR_YOU,
			url: jiraHomeRoute.path,
		},
		recent: {
			entryPoint: recentFlyoutEntrypoint,
			entryPointParams: recentEntryPointParams,
			fallback: (
				<SkeletonNavMenuItems withHeading withSearch withSubHeading withSubTitle isFlyout />
			),
			isSearchable: true,
			ItemComponent: RecentMenuLinkItemAdaptor,
			menuItemId: 'jira.sidebar.recent',
			MenuContentWrapperComponent: RecentAnalyticContextProvider,
			useItems: useRecentItems,
			viewAllUrl: `${jiraHomeRoute.path}?viewed`,
		},
		starred: {
			entryPoint: starredFlyoutEntrypoint,
			entryPointParams: starredEntryPointParams,
			fallback: <SkeletonNavMenuItems withHeading withSearch isFlyout />,
			filterConfig: {
				filters: starredFilterConfig,
				defaultSelected: [FAVORITE_TYPE_FILTER_MAP.ALL],
				hideSelectedFilterTag: [FAVORITE_TYPE_FILTER_MAP.ALL],
			},
			isSearchable: true,
			ItemComponent: StarredMenuLinkItemAdaptor,
			menuItemId: 'jira.sidebar.starred',
			MenuContentWrapperComponent: StarredAnalyticContextProvider,
			useItems: useStarredItems,
			viewAllUrl: `${jiraHomeRoute.path}?starred`,
		},
	};
}
